<app-modal-confirmation-std4-skin [dismissText]="'COMMON.Cancel' | translate"
    [header]="memo.subject"
    [submitText]="'COMMON.Confirm' | translate"
    (dismiss)="close()"
    (submitted)="sendReminder()"
    [bodyNotDesignDownload]="true"
    [headerIconPath]="'assets/images/icons/time/clock-three.svg#clock-three'">
  <ng-template>
    <div class="mb-2">
      <div class="fw-semibold m-1">
        {{'MEMOS.Type of Message' | translate}}
      </div>
      <div class="row">
        <div class="col-auto">
          <input class="form-check-input mx-2"
              type="radio"
              name="reminderRadio"
              id="urgent_approval"
              checked>
          <label class="form-check-label"
              for="urgent_approval"
              (click)="onTypeReminder('urgent_approval')">
            {{'MEMOS.Urgent approval' | translate}}
          </label>
        </div>
        <div class="col-auto">
          <input class="form-check-input me-2"
              type="radio"
              name="reminderRadio"
              id="approval_reminder">
          <label class="form-check-label"
              for="approval_reminder"
              (click)="onTypeReminder('approval_reminder')">
            {{'MEMOS.Approval reminder' | translate}}
          </label>
        </div>
      </div>
    </div>
    <h4 class="mt-2 mb-4 f-16 ms-1">
      {{'MEMOS.Approver' | translate}}
    </h4>
    <div class="px-4">
      <app-loa-checkpoints class="d-flex flex-grow-1"
          [remindMemo]="'remind'"
          (emitIndexLoaArray)="loaMemberIdList = $event"
          [memoId]="memo.id">
      </app-loa-checkpoints>
    </div>
    <div class="form-group">
      <h4 class="fs-base-l0 ms-1">{{ 'EMAIL-SETTING.MESSAGE' | translate }}</h4>
      <div class="px-1">
        <app-memo-editor-detail formMode="normal"
            [control]="detailControl">
        </app-memo-editor-detail>
      </div>
    </div>
    <div class="form"
        [formGroup]="form">
      <div class="form-group">
        <h4 class="fs-base-l0 ms-1">{{ 'COMMON.Email template language' | translate }}</h4>
        <ng-select class="std-skin mx-1"
            [items]="languages"
            (change)="setSubjectPlaceholder()"
            [notFoundText]="'SELECT.No items found'|translate"
            bindValue="value"
            formControlName="notification_language"
            [clearable]="false"
            [searchable]="false">
        </ng-select>
      </div>
    </div>
  </ng-template>
</app-modal-confirmation-std4-skin>
